import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useBearerToken } from 'src/api/useBearerToken';
import { useEnqueteCreateeApi } from 'src/api/useEnqueteCreateApi';
import { portalApi } from 'src/config';
import { setSelectedOwnerOrganization } from 'src/features/general/enquete-create/store/enqueteInfoSlice';
import useLocales from 'src/hooks/useLocales';
import { useDispatch } from 'src/redux/store';
import { addSuffix, switchLabel } from 'src/utils/labelUtils';

export const useOwnerOrganizationForm = () => {
  const { getDepartmentOrganization } = useEnqueteCreateeApi();
  const [conditions, setConditions] = useState<
    {
      key: string;
      label: string;
    }[]
  >([]);
  const { getBearerToken } = useBearerToken();
  const dispatch = useDispatch();
  const { currentLang } = useLocales();
  const isJapanese = currentLang.value === 'ja';
  const makeOwnerOrganizations = useCallback(async () => {
    const companies = (await getDepartmentOrganization()) ?? [];
    const conditions = companies.map((e) => {
      return {
        key: e.id,
        label: addSuffix(switchLabel(e.departmentNameJpn, e.departmentNameEng, isJapanese), e.departmentCode),
      };
    });
    setConditions(conditions);
    // UserInfo取得
    const token = await getBearerToken();
    const loginUserInfo = await axios.get(portalApi + '/user/v1.1/userInfo', {
      headers: {
        Authorization: token,
      },
      timeout: 60000,
    });

    // 部コードを比較、主管部のデフォルト値を取得する
    const companie = companies.find((e) => e.departmentCode === loginUserInfo?.data?.department.id);
    // デフォルト値をセット
    dispatch(
      setSelectedOwnerOrganization(
        companie
          ? {
              key: companie.id,
              label: addSuffix(switchLabel(companie.departmentNameJpn, companie.departmentNameEng, isJapanese), companie.departmentCode),
            }
          : { key: '', label: '' },
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDepartmentOrganization, isJapanese]);

  useEffect(() => {
    const init = async () => {
      await makeOwnerOrganizations();
    };
    if (conditions.length === 0) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { conditions };
};
